import * as React from "react";

import { Box, Grid, makeStyles, Theme } from "@material-ui/core";

import { LoginForm } from "client/domain";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      // put non-form content below the form on mobile
      display: "flex",
      flexDirection: "column-reverse",
      flexWrap: "initial", // grid containers have a flex wrap by default, but on the mobile layout we want to override that
    },
  },
  form: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

type Props = {
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
};

export const BaseLoginLayout: React.FC<Props> = ({
  leftColumn,
  rightColumn = <LoginForm />,
}) => {
  const classes = useStyles();
  return (
    <Grid className={classes.container} container>
      <Grid item sm={12} md={5}>
        {leftColumn}
      </Grid>
      <Grid md={1} item />
      <Grid item sm={12} md={4}>
        <Box className={classes.form}>{rightColumn}</Box>
      </Grid>
    </Grid>
  );
};
